import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import {ImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '@gl/lit/types/classes.js';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import styles from './style.scss';
import {consume} from '@lit-labs/context';
import type {SessionContextData} from '@gl/lit/contexts/session.js';
import {SessionContext} from '@gl/lit/contexts/session.js';
import {property} from 'lit-element';

export const STUDIO_LINK_ELEMENT_TAG = 'studio-link';

@customElement(STUDIO_LINK_ELEMENT_TAG)
export default class StudioLink extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @consume({context: SessionContext, subscribe: true})
  @property({type: Object})
  session?: SessionContextData;

  static get styles() {
    return [styles];
  }

  @property({type: Boolean})
  get isAuthorizedForSourceConnections() {
    return this.model.isAuthorizedForSourceConnections;
  }

  set isAuthorizedForSourceConnections(value: boolean) {
    this.handleUpdate(Msg.setIsAuthorizedForSourceConnections(value));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [STUDIO_LINK_ELEMENT_TAG]: StudioLink;
  }
}
